import Dbm from "dbm";
import Website from "../../index.js";

//import * as PIXI from "pixi.js";
//import Matter from "matter-js";

export default class PlayerInformation extends Dbm.core.BaseObject {
    _construct() {
        super._construct();

        let keyboardInput = new Website.game.screens.KeyboardInput();
        keyboardInput.item.screen = this.item;
        this.item.requireProperty("keyboardInput", keyboardInput.item);

        this.item.requireProperty("game", null);

        this.item.requireProperty("textEnvelope", 0);

        let layer = new PIXI.Container()
        this.item.requireProperty("pixiLayer", layer);

        
    }

    _callback_startClicked(aEvent) {
        //console.log("_callback_startClicked");

        this.item.game.gamePlay.controller.setupLevel();
        this.item.game.gamePlay.controller.setupCharacter();

        this.item.game.controller.startRun();
        this.item.game.controller.changeScreen("howToPlay");

        let sound = Website.game.getTextures("sounds/interface", "click-beep")[0];
        sound.play({loop: false, volume: 0.5});
    }

    _callback_backClicked() {
        this.item.game.controller.changeScreen("selectCharacter");

        let sound = Website.game.getTextures("sounds/interface", "click-beep")[0];
        sound.play({loop: false, volume: 0.5});
    }

    prepare() {
        //console.log("prepare");

        {
            const box = new PIXI.Graphics();
            box.beginFill(0xefe7e1);
            box.drawRect(0, 0, Website.game.Sizes.WIDTH, Website.game.Sizes.HEIGHT);
            box.endFill();
            this.item.pixiLayer.addChild(box);
        }

        let margin = 10;
        let boxWidth = 230;
        let boxHeight = 135;
        
        
        let textures = Website.game.getTextures("screens/select-character", "character");

        let newCharacter = new PIXI.Container();
        this.item.pixiLayer.addChild(newCharacter);
        this.item.setValue("character", newCharacter);

        let playerAnimationLayer = new PIXI.Container();
        newCharacter.addChild(playerAnimationLayer);
        this.item.setValue("playerAnimationLayer", playerAnimationLayer);

        {
            

            let sprite = new PIXI.Sprite(textures[this.item.game.playerIndex]);
            sprite.anchor.set(0.5, 1);
            sprite.x = 0.5*Website.game.Sizes.CHARACTER_WIDTH;
            playerAnimationLayer.addChild(sprite);

            let xPosition = 0.5*(Website.game.Sizes.WIDTH-2*margin-boxWidth-Website.game.Sizes.CHARACTER_WIDTH-margin);

            sprite.scale.set(1.5);
            newCharacter.position.set(xPosition+margin, margin+10);
            this.item.setValue("characterSprite", sprite);

            let reflection = new PIXI.Sprite(textures[this.item.game.playerIndex]);
            reflection.anchor.set(0.5, 1);
            reflection.x = 0.5*Website.game.Sizes.CHARACTER_WIDTH;
            reflection.scale.set(1.5, -1.5);
            reflection.alpha = 0.3;
            reflection.tint = 0xAAAAAA;
            this.item.setValue("characterReflection", reflection);

            const mask = Website.game.getSprite("screens/reflection-mask", "main");
    
            playerAnimationLayer.addChild(reflection);

            mask.x = 0.5*Website.game.Sizes.CHARACTER_WIDTH;
            playerAnimationLayer.addChild(mask);
            mask.anchor.set(0.5, 0);
            reflection.mask = mask;


            let nameText = Dbm.getRepositoryItem("game").controller.getText(this.item.game.playerName, 22, 0x000000);
            
            nameText.position.x = 0.5*(Website.game.Sizes.CHARACTER_WIDTH-nameText.width);
            nameText.position.y = 0;
            this.item.setValue("nameText", nameText)

            sprite.y = nameText.height + Website.game.Sizes.CHARACTER_HEIGHT*1.5 + 5;
            reflection.y = nameText.height + Website.game.Sizes.CHARACTER_HEIGHT*1.5 + 5;
            mask.y = reflection.y;

            playerAnimationLayer.addChild(nameText);
        }

        {
            const box = Website.game.getButton("screens/frame", "main", 0, 7);
            box.width = boxWidth;
            box.height = boxHeight;
            box.position.set(Website.game.Sizes.WIDTH-boxWidth-margin, margin)
            this.item.pixiLayer.addChild(box);

            let text = Dbm.getRepositoryItem("game").controller.getText("Information " + this.item.game.playerName, 12, 0x00000, {wordWrap: true, wordWrapWidth: boxWidth-2*10, lineHeight: 18});
            this.item.textSprite = text;
        
            text.position.x = Website.game.Sizes.WIDTH-boxWidth-margin+10;
            text.position.y = margin+10;

            this.item.pixiLayer.addChild(text);
        }

        let buttonHeight = 20;
        let buttonWidth = 120;

        
        let backButton = new PIXI.Container();
        backButton.eventMode = "static";
        backButton.on("pointerdown", this._callback_backClicked.bind(this));
        this.item.pixiLayer.addChild(backButton);
        this.item.setValue("backButton", backButton);
        
        {
            const box = Website.game.getButton("screens/button-orange");
            box.width = buttonWidth;
            box.height = buttonHeight;
            backButton.addChild(box);

            backButton.x = margin;
            backButton.y = Website.game.Sizes.HEIGHT-buttonHeight-margin;

             let text = Dbm.getRepositoryItem("game").controller.getText("TILLBAKA");
        
            text.position.x = 0.5*(buttonWidth-text.width);
            text.position.y = 0.5*(buttonHeight-text.height);

            backButton.addChild(text);
        }

        let startButton = new PIXI.Container();
        startButton.eventMode = "static";
        startButton.on("pointerdown", this._callback_startClicked.bind(this));
        this.item.pixiLayer.addChild(startButton);
        this.item.setValue("startButton", startButton);

        const box = Website.game.getButton();
        box.width = buttonWidth;
        box.height = buttonHeight;
        this.item.startButton.addChild(box);

        this.item.startButton.x = Website.game.Sizes.WIDTH-buttonWidth-margin;
        this.item.startButton.y = Website.game.Sizes.HEIGHT-buttonHeight-margin;
        
        let text = Dbm.getRepositoryItem("game").controller.getText("VÄLJ " + this.item.game.playerName);
        
        text.position.x = 0.5*(buttonWidth-text.width);
        text.position.y = 0.5*(buttonHeight-text.height);
        this.item.setValue("text", text);

        this.item.startButton.addChild(text);

        playerAnimationLayer.alpha = 0;
        startButton.alpha = 0;
        backButton.alpha = 0;

        let animationContoller = Dbm.flow.externalObject({"playerAnimationLayer": playerAnimationLayer, "startButton": startButton, "backButton": backButton});
        this.item.setValue("animationContoller", animationContoller.item);
        animationContoller.addProperty("alpha", 0, "playerAnimationLayer.alpha");
        animationContoller.addProperty("x", 0, "playerAnimationLayer.position.x");
        animationContoller.addProperty("startButtonAlpha", 0, "startButton.alpha");
        animationContoller.addProperty("backButtonAlpha", 0, "backButton.alpha");

    }

    start() {

        this.item.keyboardInput.active = true;

        let margin = 10;
        let buttonHeight = 20;
        let buttonWidth = 120;

        let textures = Website.game.getTextures("screens/select-character", "character");

        this.item.characterSprite.texture = textures[this.item.game.playerIndex];
        this.item.characterReflection.texture = textures[this.item.game.playerIndex];


        this.item.text.text = "VÄLJ " + this.item.game.playerName;
        this.item.nameText.text = this.item.game.playerName;
            
        this.item.nameText.position.x = 0.5*(Website.game.Sizes.CHARACTER_WIDTH-this.item.nameText.width);
        
        this.item.text.position.x = 0.5*(buttonWidth-this.item.text.width);
        this.item.text.position.y = 0.5*(buttonHeight-this.item.text.height);

        this.item.textEnvelope = 0;
        this.item.properties.textEnvelope.animateValue(1, 14, 0, (aValue) => {return aValue});
        
        let animationController = this.item.animationContoller;
        animationController.alpha = 0;
        animationController.properties.alpha.animateValue(1, 0.3, 0);

        animationController.x = -10;
        animationController.properties.x.animateValue(0, 0.7, 0);

        animationController.startButtonAlpha = 0;
        animationController.properties.startButtonAlpha.animateValue(1, 0.7, 3);

        animationController.backButtonAlpha = 0;
        animationController.properties.backButtonAlpha.animateValue(1, 0.8, 3);
    }

    update(aTime, aDelta) {
        
        let playerId = this.item.game.playerId;
        let texts = {
            "affe": "Svensk företagsamhet har gjort det möjligt för ett litet land att ta stor plats i världen.\nDynamiten - som uppfanns för 160 år sedan av Alfred Nobel och fortsätter att smälla högt - gav upphov till både en ny industri och stora intäkter. Något som märks än idag då Nobelpriset årligen får alla blickar att riktas mot Stockholm när vi belönar de mest banbrytande innovationerna.",
            "theo": "Det svenska musikundret är väldokumenterat och har fått hela världen att dansa - från ABBA och Ace of Base till Max Martins hitmakeri och Aviciis utsålda arenor. I denna miljö växer det sen fram nya musikentreprenörer, som kombinerar teknik och kultur. Där digital innovation alltid varit en svensk styrka, har digital distribution nu gjort att musiken kunnat nå fler än någonsin tidigare.",
            "saga": "Den nya tidens ekonomi kräver nya former av företagsamhet och nya förebilder. Med ett starkt driv går nutidens entreprenörer raskt från egna start-ups till investerande och rådgivande roller för att lyfta nästa generation. Genom att utmana gamla sanningar bryts ny mark och glastak - och vikten av tillväxt översätts i en praktik som fler förstår.",
            "svenne": "En fortsättning på Sveriges stolta tradition av uppfinningsrikedom och företagande är Svenska Kullagerfabriken det företag och den industri som växte fram runt Sven Wingqvists innovation - det självreglerande kullagret. En produkt som idag återfinns i allt från skateboards och tvättmaskiner till elmotorer och rymdfarkoster och får hela världen att rulla på.",
            "ninni": "En av de viktigaste produkterna som svensk företagsamhet och svenska företag har utvecklat är torrmjölkspulvret - en innovation som anses ha räddat miljontals barn undan svält och gjort måltidsersättning tillgängligt på platser som saknat kyld förvaring. Bakom innovationen står Ninni Kronberg, en svensk uppfinnare och näringsfysiolog, vars uppfinning la grunden till företaget Semper."
        }

        let text = texts[playerId];

        let maxLength = Math.floor(text.length*this.item.textEnvelope);

        this.item.textSprite.text = text.substring(0, maxLength);
    }

    stop() {
        this.item.textEnvelope = 0;
        
        let animationController = this.item.animationContoller;
        animationController.alpha = 0;

        animationController.x = -10;

        animationController.startButtonAlpha = 0;

        animationController.backButtonAlpha = 0;

        this.item.keyboardInput.active = false;
    }

    leftInput() {
        this._callback_backClicked();
    }

    rightInput() {
        this._callback_startClicked();
    }
}